import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import LocationSelector from './LocationSelector';
import LanguageSelector from './LanguageSelector';
import { APP_LOGO, APP_NAME, APP_TAGLINE } from './appBrand';

const Frame = ({ children, navigation, shopName }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const hasSidebar = Boolean(navigation);

  return (
    <div className={`app-frame ${hasSidebar ? 'app-frame--with-sidebar' : ''}`}>
      {hasSidebar && (
        <>
          {sidebarOpen && (
            <div
              className="sidebar-overlay"
              onClick={() => setSidebarOpen(false)}
              aria-hidden="true"
            />
          )}
          <aside className={`app-sidebar ${sidebarOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
              <button
                type="button"
                className="mobile-close-btn"
                onClick={() => setSidebarOpen(false)}
                aria-label="Close menu"
              >
                <X size={20} />
              </button>
            </div>
            {navigation}
          </aside>
        </>
      )}

      <div className={`app-main ${hasSidebar ? 'with-sidebar' : ''}`}>
        <div className="app-topbar">
        <div className="app-header">
          <div className="header-content">
            <div className="header-left">
              {hasSidebar && (
                <button
                  type="button"
                  className="mobile-menu-btn"
                  onClick={() => setSidebarOpen(true)}
                  aria-label="Open menu"
                >
                  <Menu size={22} />
                </button>
              )}

              {hasSidebar ? (
                shopName ? (
                  <div className="header-context">
                    <span className="header-context-label">Store</span>
                    <span className="header-context-value">{shopName}</span>
                  </div>
                ) : null
              ) : (
                <div className="app-title-container">
                  <img src={APP_LOGO} alt={APP_NAME} className="app-logo" />
                  <div className="app-title-section">
                    <h1 className="app-title">{APP_NAME}</h1>
                    <span className="app-subtitle">{shopName || APP_TAGLINE}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="header-actions">
              {hasSidebar && (
                <>
                  <LanguageSelector />
                  <LocationSelector />
                </>
              )}
            </div>
          </div>
        </div>
        {/* SaveBar (appBridgeShim) portals into this slot so it docks under the header */}
        <div id="app-save-bar-root" />
        </div>
        <div className="app-content">{children}</div>
      </div>
    </div>
  );
};

export default Frame;
